import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function PopularWorks() {
  const popular = comics.filter((c) => c.featured).slice(0, 5);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-900">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-12">
          <div>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full border border-primary-400/50 text-primary-300 text-xs font-medium mb-3 whitespace-nowrap">
              <i className="ri-fire-line"></i>
              热门推荐
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50">
              本周热门作品
            </h2>
          </div>
          <Link
            to="/category/lianai"
            className="inline-flex items-center gap-1 text-sm text-primary-300 hover:text-primary-200 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="flex gap-4 md:gap-5 overflow-x-auto pb-4 scrollbar-hide -mx-4 px-4 md:-mx-6 md:px-6">
          {popular.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.slug}`}
              className="flex-shrink-0 w-[200px] md:w-[240px] group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-2xl aspect-[3/4] mb-3">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  title={`哈哈漫画网 - ${comic.title}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className={`inline-block px-2.5 py-1 rounded-full text-[10px] font-medium whitespace-nowrap ${
                    comic.status === '连载中'
                      ? 'bg-accent-500/90 text-background-50'
                      : 'bg-foreground-500/80 text-background-100'
                  }`}>
                    {comic.status}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 flex items-center gap-1 bg-background-950/70 backdrop-blur-sm rounded-full px-2.5 py-1">
                  <i className="ri-star-fill text-yellow-400 text-xs"></i>
                  <span className="text-background-50 text-xs font-medium">{comic.rating}</span>
                </div>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-background-50 group-hover:text-primary-300 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <div className="flex items-center gap-2 mt-1 text-xs text-background-400">
                <span>{comic.author}</span>
                <span className="w-1 h-1 rounded-full bg-background-500"></span>
                <span>{comic.views >= 10000 ? `${(comic.views / 10000).toFixed(0)}万阅` : `${comic.views}阅`}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}